import { storyblokEditable } from "@storyblok/react";

const InfotextImage = ({ blok }) => (
    
    <div className="infotextimage-wrap flex wrap"{...storyblokEditable(blok)}>
      <div className="infotextimage-content flex flex-col">
        <h2 className="text-2xl">{blok.subheadline}</h2>
        <img className="hide-mobile pb-4" src={blok.image.filename} alt={blok.image.alt} />

        <p>
          {blok.text}
        </p>
        {/* <div>
          <button>{blok.button}</button>  
        </div> */}
        
      </div>
      <div className="hide-desktop infotextimage-img ml-8">
        <img className="" src={blok.image.filename} alt={blok.image.alt} />
      </div>
    </div>
      
);

export default InfotextImage; 